export const REVIEWS = [
  {
    author: "Leonie Schwartz",
    rating: 5,
    text: "Je recommande cet artisan, très professionnel, m'a résolu la chaudière en quelques minutes. Je recommande vivement. Merci pour son efficacité et rapidité.",
    date: "Mars 2026",
    source: "Google",
  },
  {
    author: "margau kitt",
    rating: 5,
    text: "Intervention rapide, me trouve toujours des solutions adaptées.",
    date: "Avril 2026",
    source: "Google",
  },
];
